/**
 * The three things curation can say about a title.
 *
 * The admin screens render this list as a control and the API validates
 * against it, so both sides have to hold the same three strings. It sat in
 * `admin/games.ts` next to `decideCuration`, which needs the database — this is
 * the half that does not.
 */
export const CURATION_DECISIONS = ['in_review', 'approved', 'rejected'] as const;

export type CurationDecision = (typeof CURATION_DECISIONS)[number];
